import { SxProps } from '@mui/material';

export const containerStyle: SxProps = {
  backgroundColor: '#FAFAFA',
  borderRadius: '24px',
  padding: '64px 64px',
  boxShadow: ' 0px 3.342px 10.026px 0px rgba(34, 34, 34, 0.10)',
  display: 'flex',
  gap: '8px',
  flexDirection: 'column',
  '.MuiFormHelperText-root': {
    marginLeft: '0',
  },
  '@media only screen and (max-width: 600px)': {
    boxShadow: 'none',
    borderRadius: 0,
    marginTop: '20px',
    p: {
      textAlign: 'center',
    },
    'p.txt-mobile': {
      fontSize: '32px',
    },
  },
  '@media only screen and (max-width: 768px)': {
    boxShadow: 'none',
    p: {
      textAlign: 'center',
    },
    'p.txt-mobile': {
      fontSize: '32px',
    },
  },
  '@media only screen and (max-width: 850px)': {
    boxShadow: 'none',
    p: {
      textAlign: 'center',
    },
    div: {
      justifyContent: 'center',
    },
  },
  '@media only screen and (max-width: 900px)': {
    boxShadow: 'none',
    padding: '20px 0px',
    width: '100%',
    p: {
      textAlign: 'center',
    },
    div: {
      justifyContent: 'center',
    },
    hr: {
      marginTop: '12px',
      marginBottom: '12px',
    },
  },
};

export const buttonsContainer: SxProps = {
  margin: '0 auto',
  height: '70px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '24px',
  flexWrap: 'wrap',
  padding: '0 12px',
  '@media only screen and (max-width: 600px)': {
    padding: '0 24px',
  },
};
